export default {
  nav: {
    home: 'Accueil',
    shoppingGuide: 'Guide d\'Achat',
    guide: 'Guide de la Spreadsheet',
    categories: 'Catégories',
    buyNow: 'Acheter Maintenant',
    language: 'Langue',
  },
  hero: {
    badge: 'Ressource Indépendante · Mise à Jour · Axée Sécurité',
    title: 'USFans Spreadsheet — Trouvez Vendeurs, Produits et Ressources',
    subtitle:
      'Explorez les dernières ressources USFans spreadsheet, listes de vendeurs, guides produits, informations QC, conseils de livraison, avis et ressources de sécurité, le tout au même endroit.',
    cta1: 'USFans Spreadsheet',
    cta2: 'Acheter Maintenant',
    trust: 'Ressource Indépendante · Mise à Jour · Axée Sécurité',
    disclaimer:
      'USFansSheet.link est une ressource d\'information indépendante et n\'est pas nécessairement affiliée à USFans. Vérifiez toujours les informations importantes avant d\'acheter.',
    cardTitle: 'Aperçu de la Spreadsheet',
    cardSeller: 'Vendeur',
    cardProduct: 'Produit',
    cardCategory: 'Catégorie',
    cardQc: 'QC',
    cardShipping: 'Livraison',
    cardStatus: 'Statut',
    cardUpdated: 'Mis à jour',
  },
  categorySection: {
    title: 'Parcourir les Catégories de Produits',
    subtitle:
      'Accédez directement à la catégorie recherchée. Chaque lien ouvre la section correspondante sur le site principal.',
    dropdownLabel: 'Choisir une catégorie',
    allCategories: 'Toutes les catégories',
    goTo: 'Ouvrir la catégorie',
  },
  about: {
    title: 'Qu\'est-ce qu\'une USFans Spreadsheet ?',
    subtitle:
      'Une façon organisée de découvrir des produits, des vendeurs et des ressources d\'achat sans chercher dans des informations dispersées.',
    p1: 'Une USFans spreadsheet est une façon structurée de découvrir des produits, des vendeurs et des ressources d\'achat utiles sans chercher dans des informations dispersées. Notre hub USFans Spreadsheet organise les informations des vendeurs, les catégories de produits, les ressources QC, les guides de livraison et les informations connexes dans un format plus facile à utiliser.',
    p2: 'Que vous cherchiez des chaussures, des sweats, des t-shirts, des sacs ou des accessoires, vous pouvez commencer ici et poursuivre vers le site principal pour parcourir le catalogue complet.',
    cta: 'Explorer la USFans Spreadsheet',
  },
  features: {
    title: 'Tout ce qu\'il Faut pour Explorer USFans au Même Endroit',
    subtitle: 'Un point de départ clair pour les vendeurs, produits, QC, livraison et sécurité.',
    seller: {
      title: 'Découverte des Vendeurs',
      desc: 'Trouvez des ressources organisées sur les vendeurs et comparez les informations pertinentes.',
    },
    product: {
      title: 'Découverte des Produits',
      desc: 'Explorez les catégories de produits populaires et les ressources associées de la spreadsheet.',
    },
    qc: {
      title: 'Ressources QC',
      desc: 'Apprenez comment les informations et photos QC aident à évaluer les produits.',
    },
    shipping: {
      title: 'Guides de Livraison',
      desc: 'Comprenez les méthodes, coûts et considérations importantes de livraison.',
    },
    safety: {
      title: 'Ressources de Sécurité',
      desc: 'Apprenez à évaluer les liens, vendeurs, paiements et risques d\'achat.',
    },
    updated: {
      title: 'Ressources à Jour',
      desc: 'Gardez les informations importantes organisées et faciles à retrouver.',
    },
  },
  article: {
    title: 'Guide USFans Spreadsheet',
    subtitle:
      'Lisez notre guide détaillé pour comprendre les vendeurs, produits, QC, livraison et sécurité avant d\'acheter.',
    cardTitle: 'USFans Spreadsheet : Le Guide Complet',
    cardDesc:
      'Découvrez ce qu\'est une USFans spreadsheet, comment trouver vendeurs et produits, et comment acheter en sécurité.',
    readMore: 'Lire le guide complet',
    readGuide: 'Ouvrir le guide',
    minutes: '7 min de lecture',
    related: 'Guides Associés',
    tableTitle: 'Tableau de Référence Rapide',
    pros: 'Avantages',
    cons: 'Inconvénients',
    notFound: 'Guide introuvable',
  },
  articleSection: {
    title: 'Guides et Ressources USFans',
    subtitle:
      'Explorez notre bibliothèque de guides indépendants sur les vendeurs, produits, QC, livraison, coupons, sécurité et plus.',
  },
  faq: {
    title: 'Questions Fréquentes',
    subtitle: 'Réponses rapides aux questions les plus courantes sur la USFans spreadsheet.',
    q1: {
      q: 'Qu\'est-ce qu\'une USFans spreadsheet ?',
      a: 'Une USFans spreadsheet est un tableau organisé qui rassemble vendeurs, produits, catégories, informations QC et notes de livraison au même endroit.',
    },
    q2: {
      q: 'USFansSheet.link est-il affilié à USFans ?',
      a: 'Non. USFansSheet.link est une ressource d\'information indépendante et n\'est pas nécessairement affiliée à USFans.',
    },
    q3: {
      q: 'Comment trouver des produits ?',
      a: 'Utilisez le répertoire des catégories de cette page pour accéder aux chaussures, sweats, t-shirts et autres catégories sur le site principal.',
    },
    q4: {
      q: 'Dois-je vérifier le QC avant d\'acheter ?',
      a: 'Oui. Consulter les photos et notes QC peut vous aider à confirmer qu\'un article correspond à sa description avant l\'expédition.',
    },
  },
  cta: {
    title: 'Prêt à Explorer la USFans Spreadsheet ?',
    subtitle:
      'Commencez par le hub de la spreadsheet, comparez les ressources disponibles et trouvez les informations nécessaires avant de poursuivre vers le site principal.',
    button1: 'Ouvrir USFans Spreadsheet',
    button2: 'Acheter Maintenant',
  },
  footer: {
    tagline:
      'Un hub de ressources indépendant pour découvrir les vendeurs, produits, QC et informations d\'achat USFans.',
    disclaimer:
      'USFansSheet.link est une ressource d\'information indépendante et n\'est pas nécessairement affiliée ni approuvée par USFans. Les informations peuvent changer; vérifiez les détails auprès de sources officielles.',
    categories: 'Catégories',
    resources: 'Ressources',
    guide: 'Guide de la Spreadsheet',
    home: 'Accueil',
    backToTop: 'Retour en haut',
    rights: 'Tous droits réservés.',
  },
  categoryNames: {
    shoes: 'Chaussures',
    hoodies: 'Sweats / Pulls',
    tshirts: 'T-shirts',
    jackets: 'Vestes',
    pants: 'Pantalons / Shorts',
    headwear: 'Couvre-chefs',
    sets: 'Ensembles',
    underwear: 'Sous-vêtements',
    jersey: 'Maillot',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    other: 'Autres',
  },
};